import styled from "styled-components";
import { DARKER, PRIMARY } from "../../const/colors";
import { mobile_big, mobile_normal, mobile_small } from "../../const/fonts";

export const Container = styled.footer`
  min-width: 100vw;
  background-color: ${DARKER};
  color: #fff;
`;
export const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 1rem 8%;
  max-width: 2200px;

  @media screen and (max-width: 1300px) {
		padding-left: 2%;
    padding-right: 2%;
	}

  @media screen and (max-width: 972px) {
		padding: 0;
	}
  @media screen and (max-width: 768px) {
		padding-top: 2rem;
    padding-bottom: 5rem;
	}

  div.img-container {
    max-width: 430px;
  }

  @media screen and (max-width: 480px) {
		div.img-container {
      max-width: 300px;
    }
	}
`;
export const Logo = styled.img`
  width: 100%;
  //altura normal
  height: 120px;

  //altura logo navidad
 // height: 100px;
  
  object-fit: cover;
  max-width: 430px;

  @media screen and (max-width: 1200px) {
    padding-left: 2rem;
	}
  @media screen and (max-width: 480px) {
    height: auto;
    padding-left: calc(2.5%);
	}
`;
export const FooterSection = styled.div`
	display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0;
  position:relative;
  gap:25px;
  @media screen and (max-width: 972px) {
		flex-direction: column;
	}
  @media screen and (max-width: 768px) {
		padding: 0;
	}
`;
export const FooterListContainer = styled.ul``;

export const FooterListItem = styled.li`
  list-style: none;
  color: ${props => props.featured ? PRIMARY : '#fff'};
  font-weight: ${props => props.featured ? 'bold' : '300'};
  margin-bottom: ${props => props.featured ? '0.7rem' : '0.2rem'};
  font-size: 1rem;
  transition: color 0.3s ease-in;
  &:hover {
    color: ${PRIMARY};
  }

  @media screen and (max-width: 2000px) {
    font-size: 14px;
  }
  @media screen and (max-width: 1080px) {
    font-size: ${mobile_normal};
  }
 `;
export const FooterLists = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 60%;
  padding-left: 0rem;

  @media screen and (max-width: 972px) {
		width: 100%;
    padding: 0 5%;
	}

  @media screen and (max-width: 768px) {
		display: none;
	}
`;
export const FooterLicense = styled.div`
  width: 40%;
  text-align: justify;
  font-weight: 300;
  font-size: 0.9rem;
  align-self: flex-start;
  p {
    padding: 2px 0;
    color: #eee;
    //line-height: 2.5;
  }
  @media screen and (max-width: 2000px) {
    font-size: 11px;
  }

  @media screen and (max-width: 972px) {
    margin-top: 3rem;
		width: 100%;
    padding: 0 5%;
	}

  @media screen and (max-width: 768px) {
		display: none;
	}
`;
export const FooterPayments = styled.div`
  
  width: 100%;
  margin: auto;

  @media screen and (max-width: 1400px) {
		width: 100%;
	}
  @media screen and (max-width: 972px) {
		flex-direction: column;
	}

  @media screen and (max-width: 768px) {
		display: none;
	}
  `;
export const FooterPaymentTitle = styled.h4`
  font-size: 1.1rem;
  color: #fff;
  margin: 0 auto;
  margin-top: 1rem;
  text-align:center;

  @media screen and (max-width: 2000px) {
		font-size: 14px;
	}
  @media screen and (max-width: 1200px) {
		margin-bottom: 0.5rem; 
	}
  @media screen and (max-width: 972px) {
		margin-bottom: .7rem;
	}
  @media screen and (max-width: 768px) {
		font-size: ${mobile_big};
    margin-right: 0;
    margin-bottom: 0; 
    margin: 0;

	}
`
export const FooterPaymentMethods = styled.div`
  background: rgba(255,255,255,0.06);
  border-radius: 80px;
  padding: 0.5rem 2.5rem;
  margin: 1rem auto;
  width: 100%;
  & .slick-track{
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
export const PaymentMethod = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.width ? `${props.width}px` : '60px'};
  height: ${props => props.height ? `${props.height}px` : '30px'};
  margin: 0 8px;
  img {
    width: 100%;
    height: 100%;
    max-width:118px;
  }

  &.pe {
    margin: 0 1rem;
  }

  @media screen and (max-width:768px) {
    width: ${props => props.width ? `${props.width - 10}px` : '60px'};
    height: 30px;
    width:25%!important;
  }
`
export const FooterSocialMedia = styled.div`
  margin: 0 auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  position: relative;

  p {
    font-size: 1.2rem;
    margin-bottom: .5rem;
    text-align: center;
  }

  @media screen and (max-width: 2000px) {
    p {
      font-size: 12px;
    }
  }

  @media screen and (max-width: 972px) {
    p {
      margin-top: 1.5rem;
      margin-bottom: .7rem;
    }
	}

  @media screen and (max-width: 768px) {
    display: none;
	}
`;

export const FooterCopyright = styled.p`
  font-size: 1rem;
  text-align: left;
  margin-left: 2rem;
  opacity: ${props => props.responsive ? 0 : 1};

  @media screen and (max-width: 2000px) {
    font-size: 12px;
  }

  @media screen and (max-width: 972px) {
    display: ${props => props.responsive ? 'none' : 'block'};
	}

  @media screen and (max-width: 768px) {
    font-size: ${mobile_small};
    margin-left: 0;
    margin-bottom: 1rem;
	}
`;

export const WrapperMobile = styled.div`
  display: none;
  @media screen and (max-width:768px) {
    display: block;
    margin: 2rem 0;
  }
`

export const SocialMediaContainer = styled.div`
  display: none;
  @media screen and (max-width: 768px) {
    display: flex;
	}
`;

export const LangContainer = styled.div`
  display: flex;
	justify-content: space-between;
	align-items: center;

  @media screen and (max-width: 768px) {

    > div:nth-child(2) {
      padding: .4rem;
      border-right: 1px solid #fff;
      margin-right: 2rem;
      margin-left: 0.5rem;
    }
	}
`;

export const WrapperMobilePayments = styled.div`
  display: none;
  @media screen and (max-width:768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

  }

`;

export const PaymentMethodsMobile = styled.div`

  display: none;
  @media screen and (max-width:768px) {

  /* display: flex;
  //flex-direction: column;
  align-items: center;
  justify-content: center; */

  display: grid;
  grid-template-columns: repeat(3,  1fr);

  align-content: center;
  justify-items: center;

  background: rgba(255,255,255,0.06);
    border-radius: 31px;
    padding: 1rem 1rem;
    margin: 1rem auto;

  > div {
   /*  width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 0; */
  }
}
`;
export const LicenseMobile = styled.div`
  display: none;
  @media screen and (max-width:768px) {
    display: block;
    width: 60%;
    margin: 0 auto;
    font-weight: 300;
    font-size: ${mobile_small};
    line-height: 1.5;
    text-align: center;
    margin-bottom: 2rem;
    p {
      padding: .7rem 0;
    }
  }
  @media screen and (max-width:480px) {
    width: 80%;
    margin-bottom: 1rem;
  }
`
export const Buttonpdf = styled.div`
  position: absolute;
  top: 35px;
  right: 10px;
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-name: pulse;
  animation-name: pulse;
  z-index:1;
  @-webkit-keyframes pulse {
    from {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  
    50% {
      -webkit-transform: scale3d(1.05, 1.05, 1.05);
      transform: scale3d(1.05, 1.05, 1.05);
    }
  
    to {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
  
  @keyframes pulse {
    from {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  
    50% {
      -webkit-transform: scale3d(1.05, 1.05, 1.05);
      transform: scale3d(1.05, 1.05, 1.05);
    }
  
    to {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
  a{
      display: flex;
      justify-content: center;
      align-items: center;
      position:relative;
  }
  .svgicon{
    background: linear-gradient(0deg, #ff6a00, #ffcc00 65%);
    border-radius: 50%;
    width: 33px;
    position: absolute;
    left: 0px;
    top: -3px;
  }
  .buttontext{
    margin:0;
    background: white;
    color: black;
    border-radius: 20px;
    padding: 0.25rem 0.50rem 0.25rem 0.50rem;
    font-weight: bold;
    font-size: 16px;
    font-style: italic;
  }
  .freeicon{
    font-size: 10px;
    position: absolute;
    top: -25px;
    right: 20px;
    background: linear-gradient(0deg, #ff6a00, #ffcc00 65%);
    padding: 0.45rem 0.25rem;
    border-radius: 5px;
    font-weight: bold;
    color: rgb(12, 14, 30);
    //box-shadow: rgb(47, 46, 46) 1px 1px 5px inset
  }
  .freeicon::after{
    content: "";
    position: absolute;
    bottom: -4px;
    right: 13px;
    transform: rotate(45deg);
    border-right: 10px solid #ff6a00;
    border-top: 10px solid #ffcd0000;
  }
  @media screen and (max-width:780px) {
    display:none;
  }
`
export const Buttonpdfmovil = styled.div`
display:none;
@media screen and (max-width:780px) {
  display:block;
  margin-top:2rem;
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-name: pulse;
  animation-name: pulse;
  position:relative;
  @-webkit-keyframes pulse {
    from {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  
    50% {
      -webkit-transform: scale3d(1.05, 1.05, 1.05);
      transform: scale3d(1.05, 1.05, 1.05);
    }
  
    to {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
  
  @keyframes pulse {
    from {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  
    50% {
      -webkit-transform: scale3d(1.05, 1.05, 1.05);
      transform: scale3d(1.05, 1.05, 1.05);
    }
  
    to {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
  a{
      display: flex;
      justify-content: center;
      align-items: center;
      position:relative;
  }
  .svgicon{
    background: linear-gradient(0deg, #ff6a00, #ffcc00 65%);
    border-radius: 50%;
    width: 33px;
    position: absolute;
    left: 0px;
    top: -3px;
  }
  .buttontext{
    margin:0;
    background: white;
    color: black;
    border-radius: 20px;
    padding: 0.25rem 0.50rem 0.25rem 0.50rem;
    font-weight: bold;
    font-size: 16px;
    font-style: italic;
  }
  .freeicon{
    font-size: 10px;
    position: absolute;
    top: -25px;
    right: 20px;
    background: linear-gradient(0deg, #ff6a00, #ffcc00 65%);
    padding: 0.45rem 0.25rem;
    border-radius: 5px;
    font-weight: bold;
    color: rgb(12, 14, 30);
    //box-shadow: rgb(47, 46, 46) 1px 1px 5px inset
  }
  .freeicon::after{
    content: "";
    position: absolute;
    bottom: -4px;
    left: 18px;
    transform: rotate(45deg);
    border-right: 10px solid rgb(255, 206, 5);
    border-top: 10px solid #ffcd0000;
  }
  
  }
`
export const Btnonfire = styled.a`
    position: fixed;
    bottom: 25px;
    right: 30px;
    width: 75px;
    height: 75px;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    .textflame{
      display: flex;
      position: relative;
      -webkit-box-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      width: 75px;
      height: 75px;
      z-index: 10;
      text-align: center;
      cursor: pointer;
      background-position: center;
      background-size: cover;
      color: #ffffff;
      text-shadow: 2px 1px 0px black;
    }
    .flames {
     position: absolute;
     bottom: 35%;
     left: 50%;
     width: 80%;
     height: 80%;
     transform: translateX(-50%) rotate(45deg);
    }
    .flames .flame {
      position: absolute;
      right: 0%;
      bottom: 0%;
      width: 0%;
      height: 0%;
      background-color: #FFDC01;
      border-radius: 1vw;
    }
    .flames .flame:nth-child(2n+1) {
      -webkit-animation: flameodd 1.5s ease-in infinite;
              animation: flameodd 1.5s ease-in infinite;
    }
    .flames .flame:nth-child(2n) {
      -webkit-animation: flameeven 1.5s ease-in infinite;
              animation: flameeven 1.5s ease-in infinite;
    }
    .flames .flame:nth-child(1) {
      -webkit-animation-delay: 0s;
              animation-delay: 0s;
    }
    .flames .flame:nth-child(2) {
      -webkit-animation-delay: 0.375s;
              animation-delay: 0.375s;
    }
    .flames .flame:nth-child(3) {
      -webkit-animation-delay: 0.75s;
              animation-delay: 0.75s;
    }
    .flames .flame:nth-child(4) {
      -webkit-animation-delay: 1.125s;
              animation-delay: 1.125s;
    }
    @-webkit-keyframes flameodd {
      0%, 100% {
        width: 0%;
        height: 0%;
      }
      25% {
        width: 100%;
        height: 100%;
      }
      0% {
        background-color: #FFDC01;
        z-index: 1000000;
      }
      40% {
        background-color: #FDAC01;
        z-index: 1000000;
      }
      100% {
        background-color: #F73B01;
        z-index: -10;
      }
      0% {
        right: 0%;
        bottom: 0%;
      }
      25% {
        right: 1%;
        bottom: 2%;
      }
      100% {
        right: 150%;
        bottom: 170%;
      }
    }

    @keyframes flameodd {
      0%, 100% {
        width: 0%;
        height: 0%;
      }
      25% {
        width: 100%;
        height: 100%;
      }
      0% {
        background-color: #FFDC01;
        z-index: 1000000;
      }
      40% {
        background-color: #FDAC01;
        z-index: 1000000;
      }
      100% {
        background-color: #F73B01;
        z-index: -10;
      }
      0% {
        right: 0%;
        bottom: 0%;
      }
      25% {
        right: 1%;
        bottom: 2%;
      }
      100% {
        right: 150%;
        bottom: 170%;
      }
    }
    @-webkit-keyframes flameeven {
      0%, 100% {
        width: 0%;
        height: 0%;
      }
      25% {
        width: 100%;
        height: 100%;
      }
      0% {
        background-color: #FFDC01;
        z-index: 1000000;
      }
      40% {
        background-color: #FDAC01;
        z-index: 1000000;
      }
      100% {
        background-color: #F73B01;
        z-index: -10;
      }
      0% {
        right: 0%;
        bottom: 0%;
      }
      25% {
        right: 2%;
        bottom: 1%;
      }
      100% {
        right: 170%;
        bottom: 150%;
      }
    }
    @keyframes flameeven {
      0%, 100% {
        width: 0%;
        height: 0%;
      }
      25% {
        width: 100%;
        height: 100%;
      }
      0% {
        background-color: #FFDC01;
        z-index: 1000000;
      }
      40% {
        background-color: #FDAC01;
        z-index: 1000000;
      }
      100% {
        background-color: #F73B01;
        z-index: -10;
      }
      0% {
        right: 0%;
        bottom: 0%;
      }
      25% {
        right: 2%;
        bottom: 1%;
      }
      100% {
        right: 170%;
        bottom: 150%;
      }
    }
  @media screen and (max-width:780px) {
    bottom: 120px;
    right: 20px;
    .flames {
      position: absolute;
      bottom: 15%;
    }
  }

  @media screen and (max-width:1279px) {
    bottom: 120px;
  }
`
export const Btnonfire2 = styled.a`
    position: fixed;
    bottom: 25%;
    right: 30px;
    width: 75px;
    height: 75px;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    .textflame{
      display: flex;
      position: relative;
      -webkit-box-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      align-items: center;
      border-radius: 50%;
      font-size: 12px;
      font-weight: bold;
      padding: 10px 0px;
      width: 75px;
      height: 75px;
      z-index: 10;
      text-align: center;
      cursor:pointer;
      text-shadow: black 2px 2px 4px;
    }
    .fire-center {
      position: absolute;
      height: 100%;
      width: 100%;
      animation: scaleUpDown 3s ease-out;
      animation-iteration-count: infinite;
      animation-fill-mode: both;
      .main-fire {
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: radial-gradient(
          farthest-corner at 10px 0,
          #d43300 0%,
          #ef5a00 95%
        );
        transform: scaleX(0.8) rotate(45deg);
        border-radius: 0 40% 60% 40%;
        filter: drop-shadow(0 0 10px #d43322);
      }

      .particle-fire {
        position: absolute;
        top: 60%;
        left: 45%;
        width: 10px;
        height: 10px;
        background-color: #ef5a00;
        border-radius: 50%;
        filter: drop-shadow(0 0 10px #d43322);
        animation: particleUp 2s ease-out 0;
        animation-iteration-count: infinite;
        animation-fill-mode: both;
      }
    }

    .fire-right {
      height: 100%;
      width: 100%;
      position: absolute;
      animation: shake 2s ease-out 0;
      animation-iteration-count: infinite;
      animation-fill-mode: both;

      .main-fire {
        position: absolute;
        top: 15%;
        right: -25%;
        width: 80%;
        height: 80%;
        background-color: #ef5a00;
        transform: scaleX(0.8) rotate(45deg);
        border-radius: 0 40% 60% 40%;
        filter: drop-shadow(0 0 10px #d43322);
      }

      .particle-fire {
        position: absolute;
        top: 45%;
        left: 50%;
        width: 15px;
        height: 15px;
        background-color: #ef5a00;
        transform: scaleX(0.8) rotate(45deg);
        border-radius: 50%;
        filter: drop-shadow(0 0 10px #d43322);
        animation: particleUp 2s ease-out 0;
        animation-iteration-count: infinite;
        animation-fill-mode: both;
      }
    }

    .fire-left {
      position: absolute;
      height: 100%;
      width: 100%;
      animation: shake 3s ease-out 0;
      animation-iteration-count: infinite;
      animation-fill-mode: both;

      .main-fire {
        position: absolute;
        top: 15%;
        left: -20%;
        width: 80%;
        height: 80%;
        background-color: #ef5a00;
        transform: scaleX(0.8) rotate(45deg);
        border-radius: 0 40% 60% 40%;
        filter: drop-shadow(0 0 10px #d43322);
      }

      .particle-fire {
        position: absolute;
        top: 10%;
        left: 20%;
        width: 10%;
        height: 10%;
        background-color: #ef5a00;
        border-radius: 50%;
        filter: drop-shadow(0 0 10px #d43322);
        animation: particleUp 3s infinite ease-out 0;
        animation-fill-mode: both;
      }
    }

    .fire-bottom .main-fire {
      position: absolute;
      top: 30%;
      left: 20%;
      width: 75%;
      height: 75%;
      background-color: #ff7800;
      transform: scaleX(0.8) rotate(45deg);
      border-radius: 0 40% 100% 40%;
      filter: blur(10px);
      animation: glow 2s ease-out 0;
      animation-iteration-count: infinite;
      animation-fill-mode: both;
    }
    @keyframes scaleUpDown {
        0%,
        100% {
          transform: scaleY(1) scaleX(1);
        }
        50%,
        90% {
          transform: scaleY(1.1);
        }
        75% {
          transform: scaleY(0.95);
        }
        80% {
          transform: scaleX(0.95);
        }
      }

    @keyframes shake {
        0%,
        100% {
          transform: skewX(0) scale(1);
        }
        50% {
          transform: skewX(5deg) scale(0.9);
        }
      }

    @keyframes particleUp {
        0% {
          opacity: 0;
        }
        20% {
          opacity: 1;
        }
        80% {
          opacity: 1;
        }
        100% {
          opacity: 0;
          top: -100%;
          transform: scale(0.5);
        }
      }

    @keyframes glow {
        0%,
        100% {
          background-color: #ef5a00;
        }
        50% {
          background-color: #ff7800;
        }
      }
`
